module.exports = __webpack_public_path__ + "img/image9@2x.d456e97b.png";